import Modal from "react-bootstrap/Modal";

import DocumentUploadModalBody from "./documentUploadModalBody";

const DocumentUploadModal = (props) => {
  const {
    uploadFile,
    uploadProgress,
    uploadStates,
    progressTitle,
    progressDescription,
    ...modalProps
  } = props;
  return (
    <>
      <Modal
        {...modalProps}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="fileModal"
      >
        <DocumentUploadModalBody
          uploadFile={uploadFile}
          uploadProgress={uploadProgress}
          uploadStates={uploadStates}
          progressTitle={progressTitle}
          progressDescription={progressDescription}
          hideModal={props.onHide}
        />
      </Modal>
    </>
  );
};

export default DocumentUploadModal;
